"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PeopleIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.48 9c1.363 0 2.467-1.12 2.467-2.5S12.843 4 11.48 4 9.013 5.12 9.013 6.5 10.118 9 11.48 9zM4.575 8c1.634 0 2.96-1.343 2.96-3s-1.326-3-2.96-3c-1.635 0-2.96 1.343-2.96 3s1.325 3 2.96 3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.548 14a3.931 3.931 0 013.931-3.909h.58c2.33 0 4.36 1.586 4.925 3.846a.05.05 0 01-.049.063H6.548z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M.161 13.194A5.217 5.217 0 015.277 9h.217a5 5 0 015 5H.074a.061.061 0 01-.06-.073l.147-.733z"
  })))
});
PeopleIcon.displayName = 'PeopleIcon';
var _default = exports.default = PeopleIcon;